import { Box, Stack, Tooltip, Typography } from '@mui/material';
import { VirtualProviderPlayerDto } from '../../models/dtos/VirtualProviderCatalogDto';

const skillColor = (value: number) => {
    if (value >= 0.5) return '#2e7d32';
    if (value > 0.25) return '#fbc02d';
    return '#d32f2f';
};

export default function VirtualPlayerSkills(props: {
    player: VirtualProviderPlayerDto;
    variant?: 'compact' | 'labeled';
}) {
    const { player } = props;
    const skills = [
        ['Strength', player.strength],
        ['Technique', player.technique],
        ['Intelligence', player.intelligence],
    ] as const;

    if (props.variant === 'labeled') {
        return <Stack spacing={1.25} sx={{ mt: 1 }}>
            {skills.map(([label, rawValue]) => {
                const value = Math.max(0, Math.min(1, rawValue));
                return <Stack key={label} direction="row" spacing={1.5} alignItems="center" aria-label={`${label} ${value.toFixed(2)}`}>
                    <Typography variant="body2" sx={{ width: 88, flexShrink: 0 }}>{label}</Typography>
                    <Box sx={{ flex: 1, height: 8, bgcolor: 'action.hover', borderRadius: 4, overflow: 'hidden' }}>
                        <Box sx={{ width: `${value * 100}%`, height: '100%', bgcolor: skillColor(value), borderRadius: 4 }} />
                    </Box>
                    <Typography variant="body2" sx={{ width: 36, flexShrink: 0, textAlign: 'right', fontVariantNumeric: 'tabular-nums' }}>
                        {value.toFixed(2)}
                    </Typography>
                </Stack>;
            })}
        </Stack>;
    }

    return <Stack spacing={0.4} alignItems="center" aria-label={`Strength ${player.strength}, technique ${player.technique}, intelligence ${player.intelligence}`}>
        {skills.map(([label, rawValue]) => {
            const value = Math.max(0, Math.min(1, rawValue));
            return <Tooltip key={label} title={`${label}: ${value.toFixed(2)}`} placement="right" arrow>
                <Box sx={{ width: 52, height: 4, bgcolor: 'action.hover', borderRadius: 2, display: 'flex', justifyContent: 'flex-start', overflow: 'hidden' }}>
                    <Box sx={{ width: `${value * 100}%`, height: '100%', bgcolor: skillColor(value), borderRadius: 2 }} />
                </Box>
            </Tooltip>;
        })}
    </Stack>;
}
